import { Navigate, Outlet, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuthStore } from '../../features/auth/model/auth.store';
import { Spinner } from '../../shared/ui/Button';

function BootingScreen() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-tg-bg-deep">
      <div className="flex items-center gap-3 text-tg-text-secondary">
        <Spinner size="lg" />
        <span>Загрузка…</span>
      </div>
    </div>
  );
}

export function RequireAuth() {
  const status = useAuthStore((state) => state.status);
  const location = useLocation();

  if (status === 'booting') {
    return <BootingScreen />;
  }

  if (status !== 'authenticated') {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return <Outlet />;
}

export function RequireAnonymous() {
  const status = useAuthStore((state) => state.status);
  const location = useLocation();

  if (status === 'booting') {
    return <BootingScreen />;
  }

  if (status === 'authenticated') {
    const from = (location.state as { from?: string } | null)?.from ?? '/today';
    return <Navigate to={from} replace />;
  }

  return <Outlet />;
}

export function RequireAdmin({ children }: { children: ReactNode }) {
  const status = useAuthStore((state) => state.status);
  const user = useAuthStore((state) => state.user);

  if (status === 'booting') {
    return <BootingScreen />;
  }

  if (status !== 'authenticated' || user === null) {
    return <Navigate to="/login" replace />;
  }

  if (!user.isAdmin) {
    return <Navigate to="/today" replace />;
  }

  return children;
}
